import { Router } from '@angular/router';
import { Injectable, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as fromRoot from '../../store/reducers';
import * as userActions from '../../store/actions/user';
import { getSelected } from '../../store/reducers/user';
import { AppUser } from '../../models/user.model';


@Injectable()
export class AuthService implements OnDestroy {

  private token: string;
  private user: AppUser = <AppUser>{};
  private subscriber: any;

  constructor(private store: Store<fromRoot.AppState>,
              private router: Router) {

    this.user.isLogged = false;

    this.subscriber = this.store.pipe(select(fromRoot.selectUserState()))
      .subscribe((state: any) => {
        this.user = getSelected(state);
        // @todo: token life expectancy
        const cachedUser = JSON.parse(localStorage.getItem('user'));
        if (!this.user && cachedUser) {
          this.store.dispatch(new userActions.LoginSuccess(cachedUser));
        }
        if (this.user && this.router.url.includes('/manage/login')) {
          this.user.isLogged = true;
          // clear all user's data saved into the local storage
          // localStorage.clear();
          this.router.navigate(['manage']);
        }
      });

    // get routes
    // this.navigationEnd$ = router.events.pipe(filter((event: NavigationEnd) => event instanceof NavigationEnd));
  }

  ngOnDestroy() {
    this.subscriber.unsubscribe();
  }

  signupUser(email: string, password: string) {
    // your code for signing up the new user
  }

  signinUser(email: string, password: string) {
    // your code for checking credentials and getting tokens for for signing in user
  }

  authenticate(login: string, password: string) {
    this.store.dispatch(new userActions.Login({login: login, password: password}));
  }

  logout() {
    this.token = null;
    this.store.dispatch(new userActions.Logout());
  }

  getToken() {
    return this.user ? this.user.token : null;
  }

  isAuthenticated() {
    // here you can check if user is authenticated or not through his token
    // update user's last visit time
    return this.user && !!this.user.isLogged;
  }

  checkPermission(urlPath: string) {

    if (this.user.isAdmin || !this.user || ['page/forbidden', 'personal/profile'].includes(urlPath)) {
      return;
    }

    if (this.user.isNeedResetPassword === 1) {
      this.router.navigate(['/manage/personal/profile']);
      return;
    }

    const row: any = this.user.permissions_front.filter( (p: any) => p.Path === urlPath)[0];

    if (!row) {
      console.log('FORBIDDEN ALL');
      this.router.navigate(['/manage/page/forbidden']);
      return;
    }

    if (!row.E && urlPath.startsWith(urlPath + '/edit')) {
      console.log('FORBIDDEN EDIT', urlPath);
      this.router.navigate(['/manage/page/forbidden']);
      return;
    }

    if (!row.A && urlPath.startsWith(urlPath + '/add')) {
      console.log('FORBIDDEN ADD', urlPath);
      this.router.navigate(['/manage/page/forbidden']);
      return;
    }

    if (!row.S && urlPath.startsWith(urlPath + '/search')) {
      console.log('FORBIDDEN SEARCH', urlPath);
      this.router.navigate(['/manage/page/forbidden']);
      return;
    }

    if (!row.RA || !row.RO) {
      console.log('FORBIDDEN READ', urlPath);
      this.router.navigate(['/manage/page/forbidden']);
      return;
    }
  }

}
